define([], function() {

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return (value && typeof value == 'object') || false;
  }

  return isObjectLike;
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-amd/modern/internal/isObjectLike.js
// module id = 10
// module chunks = 0